import { render } from "./MiniLogo.vue?vue&type=template&id=a395c270"
import script from "./MiniLogo.vue?vue&type=script&lang=js"
export * from "./MiniLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__